{
  "changeCurrency": "表示通貨を変更",
  "approx": "≈ {value}",
  "disclaimer": "換算価格は目安です。入札およびお支払いはすべて英ポンド（GBP）で行われます。",
  "currencies": {
    "gbp": "英ポンド",
    "hkd": "香港ドル",
    "jpy": "日本円",
    "usd": "米ドル",
    "eur": "ユーロ"
  }
}
